export default __webpack_public_path__ + "static/media/digital-timez.4760593e.png";